module.exports = __webpack_public_path__ + "static/media/ieee-yp.e74b9c72.jpeg";